(function (angular) {
    "use strict";
    var fmgApp = angular.module('FmgProduceSuite-Launcher');

    fmgApp.controller('HandoffController', function ($scope,$state, authenticationService, $stateParams, screenBlockService,Analytics) {


        var stringToken = decodeURIComponent($stateParams.tkn);
        var token = JSON.parse(stringToken);


        Analytics.trackEvent('handoff', token.identity.AccountName);

        authenticationService.pushToken(stringToken);

        $state.go('list');
    });
}) ( window.angular );